import React, { useMemo } from 'react'
import { injectIntl } from 'react-intl'
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import { SORT_OPTIONS } from 'routes/App/Apps/MyJobs/Common/constants'
import messages from 'routes/App/Apps/MyJobs/translate'
import { SortFilterTypes } from './SortFilter.types'

const SortFilter = ({
  currentSorting,
  saveSorting,
  intl: { formatMessage },
}: SortFilterTypes) => {
  const sortOptions = useMemo(
    () => [
      {
        id: SORT_OPTIONS.LAST_UPDATED_DESC,
        name: `${formatMessage(messages.lastUpdated)}: ${formatMessage(
          messages.newestToOldest,
        )}`,
      },
      {
        id: SORT_OPTIONS.LAST_UPDATED_ASC,
        name: `${formatMessage(messages.lastUpdated)}: ${formatMessage(
          messages.oldestToNewest,
        )}`,
      },
      {
        id: SORT_OPTIONS.DUE_DATE_DESC,
        name: `${formatMessage(messages.due)} ${formatMessage(
          messages.date,
        )}: ${formatMessage(messages.newestToOldest)}`,
      },
      {
        id: SORT_OPTIONS.DUE_DATE_ASC,
        name: `${formatMessage(messages.due)} ${formatMessage(
          messages.date,
        )}: ${formatMessage(messages.oldestToNewest)}`,
      },
      {
        id: SORT_OPTIONS.START_DATE_DESC,
        name: `${formatMessage(messages.start)} ${formatMessage(
          messages.date,
        )}: ${formatMessage(messages.newestToOldest)}`,
      },
      {
        id: SORT_OPTIONS.START_DATE_ASC,
        name: `${formatMessage(messages.start)} ${formatMessage(
          messages.date,
        )}: ${formatMessage(messages.oldestToNewest)}`,
      },
      {
        id: SORT_OPTIONS.CREATED_DATE_DESC,
        name: `${formatMessage(messages.created)} ${formatMessage(
          messages.date,
        )}: ${formatMessage(messages.newestToOldest)}`,
      },
      {
        id: SORT_OPTIONS.CREATED_DATE_ASC,
        name: `${formatMessage(messages.created)} ${formatMessage(
          messages.date,
        )}: ${formatMessage(messages.oldestToNewest)}`,
      },
    ],
    [],
  )

  const handleFilterChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value: targetValue } = event.target

    if (targetValue !== currentSorting) {
      saveSorting(targetValue as string)
    }
  }

  return (
    <FormControl fullWidth>
      <InputLabel>{formatMessage(messages.sort)}</InputLabel>
      <Select value={currentSorting} onChange={handleFilterChange}>
        {sortOptions.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default injectIntl(SortFilter)
